import { addDays, defaultBoardDate, toDateKey } from './reservation-time';

/** Overnight shifts belong to their starting date, even after business cutover. */
export function earliestReservationServiceDate(
  now: Date,
  timeZone: string,
  businessDayStartHour: number | undefined,
  previousDayWindowEnds: readonly string[]
): string {
  const businessDate = defaultBoardDate(now, timeZone, businessDayStartHour);
  return previousDayWindowEnds.some((end) => Date.parse(end) > now.getTime())
    ? addDays(toDateKey(now, timeZone), -1)
    : businessDate;
}

/** Keeping an existing booking's time must still permit editing its guest data. */
export function isUpcomingReservationStart(
  startsAt: string,
  now: Date,
  unchangedStartsAt?: string
): boolean {
  const start = Date.parse(startsAt);
  return (
    Number.isFinite(start) &&
    (start > now.getTime() || start === Date.parse(unchangedStartsAt ?? ''))
  );
}
